require('./index.scss')
import { lazy, Suspense, useState } from 'react'
import Dropdown from 'react-bootstrap/Dropdown'
import { useSelector } from 'react-redux'

import Spinner from '@/components/Spinner'
import {
  currentRegionA11yTranslationSelector,
  currentRegionFlagPathSelector
} from '@/selectors'

import Toggle from './Toggle'

const RegionDropdownList = lazy(() => import('./RegionDropdownList'))

const RegionSelector = () => {
  const currentRegion = useSelector(currentRegionA11yTranslationSelector)
  const currentRegionFlag = useSelector(currentRegionFlagPathSelector)
  const [openMenu, setOpenMenu] = useState(false)
  const onToggleMenu = () => {
    setOpenMenu(!openMenu)
  }

  return (
    <Dropdown onToggle={onToggleMenu}>
      <div className='region-selector-dropdown'>
        <Dropdown.Toggle
          as={Toggle}
          currentRegion={currentRegion}
          currentRegionFlag={currentRegionFlag}
          id='region-selector-dropdown-menu'
          show={openMenu}
        />

        <Dropdown.Menu
          bsPrefix='dropdown-menu region-selector-menu'
          show={openMenu}
        >
          <Suspense fallback={<Spinner />}>
            <RegionDropdownList />
          </Suspense>
        </Dropdown.Menu>
      </div>
    </Dropdown>
  )
}

export default RegionSelector
